module.exports = __webpack_public_path__ + "img/dashboard_alert_image.062393b.png";